import styled, { css } from 'styled-components'

import { color, radius, spacing } from '../../themes'

export const Container = styled.ul`
  width: 100%;
  color: ${color('gray.01')};
  background: ${color('gray.05')};
  padding: ${spacing(4)};
  display: flex;
  flex-direction: column;
  border-radius: ${radius('sm')};
  gap: ${spacing(2)};
`

export const Item = styled.li<{ isLink: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  word-break: break-all;

  svg {
    width: 16px;
    height: 16px;
    min-width: 16px;
  }

  ${({ isLink }) =>
    isLink &&
    css`
      color: ${color('blue.01')};

      a {
        color: ${color('blue.01')};
        text-decoration: underline;
        text-underline-position: under;
      }
    `}
`
